import { createEnumType } from 'acscp/api/models/customTypes/enumUtils';

export enum WeightUnit {
    kg = 'kg',
    lb = 'lb',
}

export const WeightUnitDynamicType = createEnumType('WeightUnit', WeightUnit);
